import * as React from "react";
import { Input, makeStyles } from "@fluentui/react-components";
import { highlightRow } from "../../../excel/highlightColumn";

export interface RowInputProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  columns: string[];
  disabled?: boolean;
}

const useStyles = makeStyles({
  root: {
    width: "120px",
  },
});

const RowInput: React.FC<RowInputProps> = ({ value, onChange, min, columns, disabled }) => {
  const styles = useStyles();
  const [displayValue, setDisplayValue] = React.useState(String(value));

  React.useEffect(() => {
    setDisplayValue(String(value));
  }, [value]);

  const handleChange = (_e: unknown, data: { value: string }) => {
    const raw = data.value.replace(/[^0-9]/g, "");
    setDisplayValue(raw);
    if (raw === "") return;
    const parsed = parseInt(raw, 10);
    if (parsed >= min) {
      onChange(parsed);
      if (columns.length > 0) {
        highlightRow(parsed, columns);
      }
    }
  };

  const handleFocus = () => {
    if (columns.length > 0) {
      highlightRow(value, columns);
    }
  };

  const handleBlur = () => {
    const parsed = parseInt(displayValue, 10);
    if (isNaN(parsed) || parsed < min) {
      setDisplayValue(String(value));
    }
  };

  return (
    <Input
      className={styles.root}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      disabled={disabled}
    />
  );
};

export default RowInput;
